<template>
  <div>
    <div class="card flex-row justify-content-between align-items-center" v-if="tasks">
      <div class="border-0 card-header col">
        <input label="Search" name="search" ref="search" id="searchBox" placeholder="Start with Search"
          :value="search_term_display" @input="search_term = $event.target.value" class="form-control" />
      </div>
    </div>
    <div v-for="(board, key, index) in tasks" :key="key">
      <div class="card">
        <el-row class="tac">
          <el-col>
            <el-menu class="el-menu-vertical bg-grey" :default-openeds="opened_groups">
              <el-submenu :index="`${index}`">
                <template slot="title">
                  <div>
                    <span class="title">{{ board[0].group.title }}</span>
                    <div class="btn-new-task" v-show="permissions.add_task">
                      <base-button type="neutral" icon size="sm" data-toggle="modal" data-target="#addTaskModal"
                        @click.stop="showAddTaskForm(board[0].group.title, key)">
                        <span class="btn-inner--icon"><i class="fas fa-plus"></i></span>
                        <span class="btn-inner--text">New</span>
                      </base-button>
                    </div>
                  </div>
                </template>
                <!-- prettier-ignore -->
                <el-table class="table-responsive table-flush" border fit empty-text=" "
                  header-row-class-name="thead-light text-center" id="table-items" ref="coloredCols" style="width: 100%"
                  :data="data && data.filter(d => d.group.id == key && d.show == true)" :key="table_key"
                  :height="board.height" :row-class-name="setRowColors" @sort-change="sort">

                  <el-table-column :fixed="is_desktop" width="400" sortable="custom" prop="name" label="Name">
                    <template v-slot="{ row }">
                      <div class="media align-items-center">
                        <div style="width:100%;text-align:left;font-weight:600;">{{ row.name }}</div>
                        <span style="float:right;padding-left:10px;" v-show="permissions.send_message">
                          <a href="#!" @click.prevent="getComments(row)" class="table-action" data-toggle="modal"
                            data-target="#updateTaskModal" data-original-title="Comment">
                            <i class="fas fa-comments fa-lg highlight"
                              v-if="row.new_updates_count > 0 && !row.has_read"></i>
                            <i class="far fa-comments fa-lg highlight" v-else-if="row.updates_count > 0"></i>
                            <i class="far fa-comment fa-lg" v-else></i>
                          </a>
                        </span>
                      </div>
                    </template>
                  </el-table-column>

                  <el-table-column v-for="(column) in columns" :key="column.id" :prop="column.prop" :label="column.label"
                    width="192" sortable="custom" v-if="!column.label.startsWith('_')">


                    <template v-slot="{ row, column, $index }">
                      <div v-if="parseSingleFieldColumnName(column.property) == 'status'">
                        <div v-if="row.status_color" style="text-align:center;border-radius:0px;"
                          :style="`color:${row.status_text_color};background-color:${row.status_color}`">
                          <div style="padding:10px;" v-if="getColumnData(row.column_values, column.property).text">
                            {{ getColumnData(row.column_values, column.property).text }}
                          </div>
                        </div>
                        <div style="text-align:center" v-else>
                          {{ getColumnData(row.column_values, column.property).text }}
                        </div>
                      </div>
                      <div
                        v-else-if="['pending', 'progress', 'type', 'alert'].includes(parseSingleFieldColumnName(column.property))">
                        <div v-if="`row[parseSingleFieldColumnName(column.property) + '_color']`"
                          :style="`color:${row[parseSingleFieldColumnName(column.property) + '_text_color']};text-align:center;border-radius:0px;background-color: ${row[parseSingleFieldColumnName(column.property) + '_color']}`">
                          <div style="padding:10px;" v-if="getColumnData(row.column_values, column.property).text">
                            {{ getColumnData(row.column_values, column.property).text }}
                          </div>
                        </div>
                        <div style="text-align:center" v-else>
                          {{ getColumnData(row.column_values, column.property).text }}
                        </div>
                      </div>
                      <div v-else>
                        {{ getColumnData(row.column_values, column.property).text }}
                      </div>
                    </template>
                  </el-table-column>

                  <!-- <el-table-column
              label="Created Date"
              prop="created_at"
              min-width="180px"
              sortable
            >
              <template v-slot="{ row }">
                  <span v-show="row.created_at">{{ moment(row.created_at).format("D MMM YYYY") }}</span>
              </template>
            </el-table-column> -->
                </el-table>
              </el-submenu>
            </el-menu>
          </el-col>
        </el-row>
        <div></div>
      </div>
    </div>

    <div class="card bg-grey" v-for="group in empty_board_groups" :key="group.id">
      <div style="padding: 15px 20px">
        <span class="title">{{ group.title }}</span>
        <div class="btn-new-task" v-show="permissions.add_task">
          <base-button type="neutral" icon size="sm" data-toggle="modal" data-target="#addTaskModal"
            @click.stop="showAddTaskForm(group.title, group.id)" style="margin: 0">
            <span class="btn-inner--icon"><i class="fas fa-plus"></i></span>
            <span class="btn-inner--text">New</span>
          </base-button>
        </div>
      </div>
      <!-- <div class="title">
        {{ group.title }}
      </div>
      <div v-show="permissions.add_task">
        <base-button
          type="neutral"
          icon
          size="sm"
          @click.stop="showAddTaskForm(group.title)"
        >
          <span class="btn-inner--icon"><i class="fas fa-plus"></i></span>
          <span class="btn-inner--text">New</span>
        </base-button>
      </div> -->
    </div>

    <!-- Task messages modal -->
    <modal :show.sync="modals.updates" :size="'xl'" v-if="selected_item" id="updateTaskModal" ref="commentModal">
      <!-- {{ selected_item }} -->
      <h6 slot="header" id="messageHeader" class="modal-title">
        {{ selected_item.name }}
      </h6>
      <div ref="messageList" class="row">
        <div id="tabContent1" class="col-lg-8 col-md-12" style="padding-right: 0" @dragover="dragOver" @drop="onDrop">
          <div id="messageList" class="message-list">
            <div v-for="item in messages" :key="item.id">
              <!-- {{ item }} -->
              <div class="message-from">
                <table>
                  <tr>
                    <td colspan="2" class="message-from--name">
                      {{ item.creator.name }}
                    </td>
                  </tr>
                  <tr v-if="item.body">
                    <!-- prettier-ignore -->
                    <td colspan="2" class="message-from--body">
                      <!-- {{ item.body }} -->
                      <span v-if="parse(item.body).length > 0" v-html="parse(item.body)"></span>
                    </td>
                  </tr>

                  <tr>
                    <td colspan="2" class="message-from--body">
                      <div v-for="asset in item.assets" :key="asset.id">
                        <a :href="asset.public_url" target="_blank">
                          <img class="message-from--asset preview" :src="asset.public_url"
                            onerror="if (this.src != '/img/file-download.png') this.src = '/img/file-download.png';" />
                          <span v-if="!asset.url_thumbnail" class="message-from--asset-name">{{ asset.name }}</span>
                        </a>
                      </div>
                    </td>
                  </tr>
                  <tr v-if="item.replies">
                    <td class="message-reply" colspan="2">
                      <div v-for="reply in item.replies" :key="reply.id">
                        <table>
                          <tr>
                            <td class="message-reply--name">
                              <span class="message-from--timestamp">{{
                                reply.created_at
                              }}</span>
                              <span class="name">
                                {{ reply.creator.name }}:</span>
                              <span class="message-from--body" v-if="reply.body" v-html="reply.body"></span>
                            </td>
                          </tr>
                        </table>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td class="message-from--timestamp">
                      {{ item.created_at }}
                      <el-popconfirm confirm-button-text="Yes" confirm-button-type="danger" cancel-button-text="No"
                        cancel-button-type="info" icon-color="red" title="Delete update?"
                        @confirm="deleteUpdate(item.id, selected_item)">
                        ><span slot="reference" v-show="permissions.delete_updates &&
                          (is_admin || is_creator(item.creator.id))
                          " class="btn-icon-only trash-icon"><i class="fas fa-trash trash-icon-red"></i></span>
                      </el-popconfirm>
                    </td>
                  </tr>
                </table>
              </div>
            </div>
          </div>

          <div id="messageFooter" class="col-12">
            <table class="message-footer" width="100%">
              <tr>
                <td>
                  <div class="message-box">
                    <label class="btn-attachment" for="file" :disabled="!permissions.send_message">
                      <span class="btn-icon-only"><i class="fas fa-plus"></i></span>
                    </label>
                    <!-- prettier-ignore -->

                    <input name="files" type="file" id="file" ref="uploader" multiple="multiple"
                      accept=".doc, .docx, application/msword, application/vnd.ms-excel, application/vnd.ms-powerpoint,text/plain, application/pdf, image/*"
                      @change="fileChanged($event)" style="display: none" :disabled="!permissions.send_message" />
                    <base-input style="width: 100%; margin-bottom: 0; margin-right: 10px">
                      <textarea placeholder="Type a message..." v-model.lazy="input.msg" class="form-control" id="msg"
                        rows="3" resize="none" :disabled="!permissions.send_message"></textarea>
                    </base-input>

                    <!-- prettier-ignore -->
                    <base-button @click="sendComment(selected_item)" class="btn-icon-only bg-primary"
                      style="margin:auto;width:44px;height:44px">
                      <i class="fas fa-paper-plane"></i>
                    </base-button>
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  <div id="messageAttachments" class="message-attachment" v-if="attachments">
                    <div class="message-attachment-pill" v-for="attachment in attachments" :key="attachment.name">
                      <div style="padding: 0 10px">
                        {{ attachment.name || "" }}
                        <span class="btn-icon-only text-danger" style="margin-left: 5px; cursor: pointer"
                          @click="deleteFile(attachment.name)"><i class="fas fa-times"></i></span>
                      </div>
                    </div>
                    <div style="padding: 5px">
                      <pre class="text-danger" v-if="error">{{
                        error || ""
                      }}</pre>
                    </div>
                  </div>
                </td>
              </tr>
            </table>
          </div>
        </div>

        <div id="tabContent2" class="col-lg-4 col-sm-12 message-task-details">
          <div id="messageTaskDetails" class="row">
            <div class="col-lg-12 message-task-details-row">
              <validation-observer v-slot="{ handleSubmit }" ref="observer">
                <form class="needs-validation" @submit.prevent="handleSubmit(update)">
                  <div class="table-responsive">
                    <table id="task_form" v-if="selected_row">
                      <tr class="col-sm-12" v-for="column in board_columns" :key="column.id"
                        v-if="!column.title.startsWith('_')">
                        <td>
                          <!-- Show * for name and detail cols -->
                          <!-- Requested by Kenneth on 22/06/2020 -->
                          <!-- prettier-ignore -->
                          <label class="important-field" :for="column.id" v-if="column.title == 'Tags / Area'">
                            {{ column.title }}*
                          </label>
                          <label :for="column.id" class="important-field" v-else-if="column.title.startsWith('Progress')">
                            {{ column.title }}
                          </label>
                          <label :for="column.id" class="regular-field" v-else>{{ column.title }}</label>

                          <!-- start name col -->
                          <div v-if="column.type == 'name'">
                            <base-input
                              v-if="!column.title.startsWith(NON_EDITABLE_COL_PREFIX) && permissions.update_task"
                              :name="column.id" rules="required" v-model.lazy="selected_row.name"></base-input>
                            <div class="form-text" v-else>
                              {{ selected_row.name }}
                            </div>
                          </div>
                          <!-- not name col, has column_values -->
                          <div v-else>
                            <!-- <div
                              class="form-text"
                              v-if="
                                column.title.startsWith(
                                  NON_EDITABLE_COL_PREFIX
                                ) || !permissions.update_task
                              "
                            >
                              {{
                                getColumnData(
                                  selected_row.column_values,
                                  column.title
                                ).text || "-"
                              }}
                            </div> -->

                            <base-input
                              v-if="column.type == 'text' || column.type == 'numeric' || column.type == 'numbers' || column.type == 'phone' || column.type == 'email'"
                              :name="column.id"
                              v-model.lazy="getColumnData(selected_row.column_values, column.title).text"
                              :disabled="column.title.startsWith(NON_EDITABLE_COL_PREFIX) || !permissions.update_task"></base-input>

                            <el-select v-if="(column.type == 'color' || column.type == 'status') && column.settings_str"
                              v-model.lazy="getColumnData(selected_row.column_values, column.title).text"
                              :value-key="column.id"
                              :disabled="column.title.startsWith(NON_EDITABLE_COL_PREFIX) || !permissions.update_task">
                              <el-option v-for="(label, key) in getColumnOptions(column)" :key="key" :label="label || '-'"
                                :value="label">
                              </el-option>
                            </el-select>

                            <el-select v-if="column.type == 'dropdown' && column.settings_str"
                              v-model.lazy="getColumnData(selected_row.column_values, column.title).text"
                              :value-key="column.id"
                              :disabled="column.title.startsWith(NON_EDITABLE_COL_PREFIX) || !permissions.update_task">
                              <el-option v-for="(label, key) in getColumnOptions(column)" :key="key"
                                :label="label.name || '-'" :value="label.name">
                              </el-option>
                            </el-select>

                            <div style="display: inline-block">
                              <el-date-picker :name="column.id" v-if="column.type == 'date'" type="date" :editable="false"
                                placeholder=""
                                :value="getColumnText(selected_row.column_values, column.title) | formatted"
                                v-on:input="setColumnText(selected_row.column_values, column.title, $event)"
                                format="dd MMM yyyy" value-format="yyyy-MM-dd"
                                :disabled="column.title.startsWith(NON_EDITABLE_COL_PREFIX) || !permissions.update_task">
                              </el-date-picker>

                              <base-button v-if="column.title.toLowerCase().includes(SINGLE_FIELD_UPDATE_CHAR)"
                                @click="updateSingleField(selected_row.column_values, column.title, $event)"
                                class="btn-icon-only bg-primary" style="border: none; margin-left: 3px"
                                :disabled="column.title.startsWith(NON_EDITABLE_COL_PREFIX) || !permissions.update_task">
                                <i class="fas fa-chevron-right"></i>
                              </base-button>
                            </div>
                          </div>
                          <!-- end name col -->
                        </td>
                      </tr>
                    </table>
                  </div>
                  <div class="row" style="padding: 5px 20px">
                    <pre class="text-danger" v-if="update_error">{{
                      update_error || ""
                    }}</pre>
                  </div>
                  <div class="row">
                    <div class="col-12 text-right">
                      <!-- <button
                type="button"
                class="btn base-button btn-outline-danger"
                @click="resetEditTaskForm()"
              >
                RESET
              </button> -->
                      <button v-if="permissions.update_task" type="submit" class="btn base-button btn-primary">
                        UPDATE
                      </button>
                    </div>
                  </div>
                </form>
              </validation-observer>
            </div>
          </div>
        </div>
      </div>
      <template slot="footer">
        <div id="messaging" class="container-fluid">
          <div class="row no-gutters">
            <div class="col-12 message-actions">
              <button type="button" class="btn base-button btn-outline-primary active" id="tab1" @click="goToTab(1)">
                CHAT HISTORY
              </button>

              <button type="button" class="btn base-button btn-outline-primary" id="tab2" @click="goToTab(2)">
                TASK DETAILS
              </button>
            </div>
          </div>
        </div>
      </template>
    </modal>
    <!-- End: Task messages modal -->

    <!-- Add task modal -->
    <modal id="addTaskModal" :show.sync="modals.add">
      <h6 slot="header" class="modal-title">{{ group_name }} > New</h6>
      <validation-observer v-slot="{ handleSubmit }" ref="observer">
        <form class="needs-validation" @submit.prevent="handleSubmit(submit)">
          <table id="task_form">
            <tr class="col-sm-12 form-group" v-for="column in board_columns" :key="column.id"
              v-if="!(column.title.startsWith('_') || column.title.endsWith('.'))">
              <td>
                <label :for="column.id" class="important-field"
                  v-if="column.id == 'name' || column.title == 'Tags / Area'">
                  {{ column.title }}*
                </label>
                <label :for="column.id" class="regular-field" v-else>{{
                  column.title
                }}</label>

                <base-input v-if="column.type == 'name'" :name="column.id" rules="required"
                  :disabled="column.title.startsWith(NON_EDITABLE_COL_PREFIX)"
                  v-model="form_column_values['name']"></base-input>

                <base-input v-if="column.type == 'text' || column.type == 'numeric' || column.type == 'numbers'"
                  :name="column.id" :disabled="column.title.startsWith(NON_EDITABLE_COL_PREFIX)"
                  v-model="form_column_values[column.id]"></base-input>

                <el-select v-if="(column.type == 'color' || column.type == 'status') && column.settings_str"
                  :disabled="column.title.startsWith(NON_EDITABLE_COL_PREFIX)" v-model="form_column_values[column.id]"
                  :value-key="column.id">
                  <el-option v-for="(label, key) in getColumnOptions(column)" :key="key" :label="label || '-'"
                    :value="label">
                  </el-option>
                </el-select>

                <el-select v-if="column.type == 'dropdown' && column.settings_str" v-model="form_column_values[column.id]"
                  :disabled="column.title.startsWith(NON_EDITABLE_COL_PREFIX)" :value-key="column.id">
                  <el-option v-for="(label, key) in getColumnOptions(column)" :key="key" :label="label.name"
                    :value="label.name">
                  </el-option>
                </el-select>

                <el-date-picker v-if="column.type == 'date'" :disabled="column.title.startsWith(NON_EDITABLE_COL_PREFIX)"
                  v-model="form_column_values[column.id]" type="date" :name="column.id" format="dd MMM yyyy"
                  value-format="yyyy-MM-dd">
                </el-date-picker>
              </td>
            </tr>
          </table>

          <div class="row">
            <div class="col-12 text-right">
              <!-- <button
                type="button"
                class="btn base-button btn-outline-danger"
                @click="reset()"
              >
                RESET
              </button> -->
              <button type="submit" class="btn base-button btn-primary">
                CREATE
              </button>
            </div>
            <div class="col-12">
              <pre style="padding: 1.25rem 1.25rem 0 1.25rem" class="text-danger" v-if="error">{{ error || "" }}</pre>
            </div>
          </div>
        </form>
      </validation-observer>
    </modal>
    <!-- End: Add task modal -->
  </div>
</template>
<script>
import store from "@/store";
import moment from "moment";
import { debounce } from "lodash";
import numeral from "numeral";

import {
  TabPane,
  Tabs,
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown,
  Select,
  Option,
  DatePicker,
  Popconfirm,
  Button,
  Row,
  Col,
  Submenu,
  Menu,
  MenuItem,
  MenuItemGroup,
} from "element-ui";

export default {
  name: "boards-table",
  components: {
    [TabPane.name]: TabPane,
    [Tabs.name]: Tabs,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [Select.name]: Select,
    [Option.name]: Option,
    [DatePicker.name]: DatePicker,
    [Popconfirm.name]: Popconfirm,
    [Button.name]: Button,
    [Row.name]: Row,
    [Col.name]: Col,
    [Submenu.name]: Submenu,
    [Menu.name]: Menu,
    [MenuItem.name]: MenuItem,
    [MenuItemGroup.name]: MenuItemGroup,
  },
  props: ["board_id", "board", "board_items"],
  data() {
    return {
      opened_groups: [],
      NON_EDITABLE_COL_PREFIX: ".",
      SINGLE_FIELD_UPDATE_CHAR: ">",
      tabMessagesClass: "active",
      tabDetailsClass: "",
      data: null,
      is_desktop: false,
      // for add task
      group_id: "",
      group_name: "",
      board_columns: [],
      form_column_values: {},
      progress_column_id: "",
      // for edit task
      selected_row: null,
      selected_row_original: null, // store original values so we can reset data to original state if user cancels the edit
      // for table and updates/messages
      table_key: 1, // determines if table should re-render
      columns: [],
      tasks: null,
      search_term_display: "",
      search_term: "",
      modals: {
        updates: false, // messages. on Monday they are referred to as updates
        add: false,
        edit: false,
      },
      selected_item: null,
      attachments: [],
      input: {
        msg: "",
      },
      error: "",
      update_error: "",
      messages: [],
      displayed_data: [],
      column_options: {},
      sort_props: {},
      default_sort: true, // only sort once on load
      refresh_data: true,
      refresh_table: false,
      message_list_height: 0,
      task_details_height: 0,
      is_comment_height_set: false,
      window_height: window.innerHeight,
      is_first_load: true,
    };
  },
  methods: {
    parse(body) {
      // Warning: filtering may cause loss of data (data that are inserted from Monday)
      let mondayUrl = "https://simplysk.monday.com/";
      let display = "";
      // monday auto adds href to file and causes filename to appear twice on UI
      // We check and remove it
      if (body.indexOf(mondayUrl) >= 0) {
        let split = body.split("</a>");

        for (let i in split) {
          let text = split[i];
          if (text.indexOf(mondayUrl) >= 0 && text.indexOf("href") >= 0) {
            // do nothing, do not append
          } else {
            // not inserted by monday. ie. user entered some text
            display += text;
          }
        }
      } else display = body;

      display = display.replace(/[\u200B-\u200D\uFEFF]/g, ""); // remove unicode zero-width chars

      while (display.startsWith("<br>")) {
        display = display.replace("<br>", "");
      }

      return display;
    },
    goToTab(tabId) {
      // reset all tabs
      let NUM_TABS = 2;
      for (let i = 1; i <= NUM_TABS; i++) {
        let tab = document.getElementById("tab" + i);
        if (tab) {
          tab.classList.remove("active");
        }
        let tabContent = document.getElementById("tabContent" + i);
        if (tabContent) {
          tabContent.style.display = "none";
        }
      }
      let activeTab = document.getElementById("tab" + tabId);
      let activeTabContent = document.getElementById("tabContent" + tabId);
      if (activeTab && activeTabContent) {
        activeTab.classList.add("active");
        activeTabContent.style.display = "block";
      }
    },
    getColumnData(column_values, column_title) {
      let pos = column_values
        .map(function (col) {
          return col.title;
        })
        .indexOf(column_title);

      let col = column_values[pos];
      return col || { text: "" };
    },
    setColumnData(row_id, column_values, name) {
      // find row
      let row = this.data.find(function (record) {
        return record.id === row_id;
      });
      if (row) {
        row.name = name;
        // set value
        // format numeric value with thousands separator (comma)
        // ie. 40000 -> 40,000
        column_values.map((col) => {
          let text = col.text;
          if (col && (col.type == "numeric" || col.type == "numbers")) {
            text = numeral(text).format("0,0.[00]");
          }
          if (col && col.type == "date" && moment(col.text).isValid()) {
            text = moment(text).format("DD MMM YYYY");
          }
          col.text = text;
        });

        row.column_values = column_values;
        this.selected_row = JSON.parse(JSON.stringify(row));
      }
    },
    getColumnText(column_values, column_title) {
      // for date columns
      let pos = column_values
        .map(function (col) {
          return col.title;
        })
        .indexOf(column_title);

      let col = column_values[pos];
      return col ? col.text : "";
    },
    setColumnText(column_values, column_title, value) {
      // for date columns
      let pos = column_values
        .map(function (col) {
          return col.title;
        })
        .indexOf(column_title);

      let col = column_values[pos];
      col.text = value;
    },
    parseSingleFieldColumnName(title) {
      // remove all accents: ".", ">", " " to get original title
      return title.replaceAll(".", "").replaceAll(">", "").toLowerCase().trim();
    },
    updateSingleField(column_values, title, event) {
      this.update_error = "";
      let column = this.selected_row.column_values.find(
        (col) => col.title == title
      );
      let og_text = column && (column.reset_text ? column.reset_text : "");
      // store.dispatch("setIsLoading", true, { root: true });
      store
        .dispatch("monday/update_column", {
          board_id: this.board_id,
          item_id: this.selected_row.id,
          column_id: column.id,
          column_type: column.type,
          value: column.text,
          column_values: [column],
          name: this.selected_row.name,
        })
        .then(() => {
          this.refresh_data = false;

          this.setColumnData(
            this.selected_row.id,
            this.selected_row.column_values,
            this.selected_row.name
          );

          this.modals.edit = false;
        })
        .catch((e) => {
          store.dispatch("setIsLoading", false, { root: true });

          // restore single field update col
          let dt = moment(og_text);
          if (dt && dt.isValid()) column.text = dt.format("DD MMM YYYY") || "";
          else column.text = og_text;

          this.update_error = `Please check that you have permission to update and data are in correct format.`;
        });
    },
    update() {
      this.update_error = "";
      // general update - exclude fields marked with ">" since it has its custom single field update
      // reset col text if it was amended, otherwise local and server is not sync'd
      // local shows amended value while server shows old value since it should not be updated
      let column_values = this.selected_row.column_values.filter(
        (col) =>
          !col.title.toLowerCase().includes(this.SINGLE_FIELD_UPDATE_CHAR)
      );

      let sf_cols = this.selected_row.column_values.filter((col) =>
        col.title.toLowerCase().includes(this.SINGLE_FIELD_UPDATE_CHAR)
      );

      store.dispatch("setIsLoading", true, { root: true });
      store
        .dispatch("monday/update_item", {
          board_id: this.board_id,
          item_id: this.selected_row.id,
          column_values: column_values,
          board_columns: this.board_columns,
          name: this.selected_row.name,
        })
        .then(() => {
          this.refresh_data = false;

          if (sf_cols) {
            sf_cols.map((sf_col) => {
              if (
                !this.selected_row.column_values.find(
                  (col) => col.title == sf_col.title
                )
              )
                this.selected_row.column_values.push(sf_col); // restore columns that are used for single field updates
            });
          }
          this.setColumnData(
            this.selected_row.id,
            this.selected_row.column_values,
            this.selected_row.name
          );

          this.modals.edit = false;
        })
        .catch((e) => {
          // console.log("e", e.response.data);
          store.dispatch("setIsLoading", false, { root: true });
          this.update_error = `Please check that you have permission to update and data are in correct format.`;
        });
    },
    submit() {
      store
        .dispatch("monday/add_new_item", {
          board_id: this.board_id,
          item_name: this.form_column_values["name"],
          group_id: this.group_id,
          column_values: this.form_column_values,
          board_columns: this.board_columns,
        })
        .then(() => {
          this.reset();
          this.modals.add = false;
          this.refresh_table = true;
          // this.should_expand_all_groups = false;
        })
        .catch((e) => {
          // console.log("e", e.response.data);
          this.update_error = `Please check that you have permission to add a task and data are in correct format.`;
        });
    },
    reset() {
      this.form_column_values = {};
      this.$refs.observer.reset();
    },
    resetEditTaskForm() {
      if (this.selected_row_original) {
        this.showEditTaskForm(this.selected_row_original);
      }
    },
    getGroupId(group_name) {
      // only for groups without items
      let board_groups =
        this.board && this.board.length > 0 ? this.board[0].groups : [];
      let group = _.find(board_groups, (grp) => {
        return grp.title == group_name;
      });
      return group.id;
    },
    showAddTaskForm(group_title, group_id) {
      this.modals.add = true;
      this.group_name = group_title;
      this.group_id = group_id;

      // get columns for board
      let board = _.find(this.board_item_list, (bil) => {
        return bil.id == this.board_id;
      });

      if (board && board.columns && board.columns.length > 0) {
        this.board_columns = _.filter(board.columns, (c) => {
          return _.includes(
            [
              "name",
              "numeric",
              "text",
              "color",
              "date",
              "dropdown",
              "phone",
              "email",
              "status", // New data type ver 2024-01
              "numbers"
            ],
            c.type
          );
        });
      }
    },
    setEditTask(row) {
      this.selected_row = JSON.parse(JSON.stringify(row));
      this.selected_row_original = Object.assign({}, row);
      // this.modals.edit = true;
      this.group_name = row.group.title || "";

      // get columns for board
      let board = _.find(this.board_item_list, (bil) => {
        return bil.id == this.board_id;
      });

      if (board && board.columns && board.columns.length > 0) {
        this.board_columns = _.filter(board.columns, (c) => {
          return _.includes(
            [
              "name",
              "numeric",
              "text",
              "color",
              "date",
              "dropdown",
              "phone",
              "email",
              "status", // New data type ver 2024-01
              "numbers"
            ],
            c.type
          );
        });
      }
    },
    dragOver(event) {
      event.preventDefault();
    },
    onDrop(event) {
      event.preventDefault();
      const files = event.dataTransfer.files;
      // this.attachments = files;
      // this.$refs.uploader.value = "";
      this.addFiles(files);
    },
    addFiles(files) {
      const MAX_FILES_UPLOAD = 8;
      this.error = "";
      if (files.length > MAX_FILES_UPLOAD) {
        this.error = `Number of files exceeds maximum of ${MAX_FILES_UPLOAD}.`;
        return;
      }

      for (var i = 0; i < files.length; i++) {
        let file = files[i];

        if (this.attachments.find((f) => f.name == file.name)) return;
        if (this.attachments.length < MAX_FILES_UPLOAD)
          this.attachments.push(file);
        else
          this.error = `Number of files exceeds maximum of ${MAX_FILES_UPLOAD}. Some files are omitted.`;
      }
      setTimeout(() => {
        this.resizeMessageList();
      }, this.attachments.length * 50);
    },
    fileChanged(event) {
      this.addFiles(event.target.files);
    },
    deleteFile(filename) {
      this.attachments = _.filter(this.attachments, (file) => {
        return file.name != filename;
      });
      this.error = "";

      setTimeout(() => {
        this.resizeMessageList();
      }, 250);
    },
    resizeMessageList() {
      let messageAttachments = document.getElementById("messageAttachments");
      if (messageAttachments) {
        let messageListHeight = this.message_list_height;
        document.getElementById("messageList").style.height =
          messageListHeight - messageAttachments.clientHeight + "px";
      } else {
        document.getElementById("messageList").style.height =
          this.message_list_height + "px";
      }
    },
    getComments(item) {
      const CHAT_HISTORY_TAB_ID = 1;
      this.setEditTask(item);

      // fetch comments for selected item
      store
        .dispatch("monday/get_board_item_messages", item.id)
        .then(() => {
          // show modal with comments
          item.has_read = true;
          // hide updates counter. once messaging box opens, we deem all messages as read
          // if (document.getElementById(item.id))
          //   document.getElementById(item.id).style.display = "none";

          this.selected_item = item;
          this.modals.updates = true;
          this.error = "";
        })
        .then(() => {
          this.setCommentsHeight();
          if (!this.is_desktop) {
            // mobile layout
            this.goToTab(CHAT_HISTORY_TAB_ID);
          }
        });
    },
    reloadComments(item) {
      // fetch comments for selected item
      store.dispatch("monday/get_board_item_messages", item.id);
    },
    setCommentsHeight() {
      this.is_comment_height_set = false;
      let modal = this.$refs.commentModal;
      let modalHeight = modal.$el.clientHeight;

      let commentModal = document.getElementById("updateTaskModal");
      if (commentModal) {
        let modalContent =
          commentModal.getElementsByClassName("modal-content")[0];
        // use clientHeight for desktop
        // use 85% height for mobile
        modalHeight = this.is_desktop
          ? modalContent.clientHeight
          : this.window_height * 0.8 - 10;
      }

      if (!this.is_comment_height_set) {
        this.is_comment_height_set = true;
        let messageHeaderHeight =
          document.getElementById("messageHeader").clientHeight + 50;
        let messageFooterHeight =
          document.getElementById("messageFooter").clientHeight;
        let messageListHeight =
          modalHeight - messageHeaderHeight - messageFooterHeight - 30;
        document.getElementById("messageList").style.height =
          messageListHeight + "px";
        this.message_list_height = messageListHeight;

        let taskDetailsHeight = modalHeight - messageHeaderHeight - 5;
        document.getElementById("tabContent2").style.height =
          taskDetailsHeight + "px";

        // console.log("this.is_desktop", this.is_desktop);
        // console.log("modalHeight", modalHeight);
        // console.log("messageHeaderHeight", messageHeaderHeight);
        // console.log("messageFooterHeight", messageFooterHeight);
        // console.log("messageListHeight", messageListHeight);

        if (!this.is_desktop) {
          // mobile layout
          taskDetailsHeight = messageListHeight + messageFooterHeight - 20;
          document.getElementById("tabContent2").style.height =
            taskDetailsHeight + "px";
        }
        this.task_details_height = taskDetailsHeight;
      }
    },
    sendComment(row) {
      let msg = this.input.msg;
      let item_id = this.selected_item.id;
      let files = this.attachments;

      if (msg.trim().length == 0 && files.length == 0) return;

      store
        .dispatch("monday/send_board_item_message", { item_id, msg, files })
        .then(() => {
          this.input.msg = "";
          this.attachments = [];
          this.error = "";

          row.updates_count += 1;

          document.getElementById("tabContent1").scrollIntoView();

          setTimeout(() => {
            this.resizeMessageList();
          }, 250);
        })
        .catch((e) => {
          console.log("e", e);
          // this.error = `${e.response.data.error}`;
        });
    },
    deleteUpdate(update_id, row) {
      store.dispatch("monday/delete_board_item_message", update_id).then(() => {
        // reload messages
        row.updates_count -= 1;
        this.reloadComments(this.selected_row);
      });
    },
    setBoardColumns(grouped_items) {
      let columns = [];
      let col_len = 0;
      if (grouped_items && Object.keys(grouped_items).length > 0) {
        let group = grouped_items[Object.keys(grouped_items)[0]];
        if (!group || group.length <= 0) return;

        let item = group[0];
        col_len = item.column_values.length;
        let is_editable = true;
        item.column_values.map((col) => {
          is_editable = true;
          if (col.title.startsWith(this.NON_EDITABLE_COL_PREFIX)) {
            is_editable = false;
          }

          // We only need one set of cols for header
          columns.push({
            id: col.id,
            prop: col.title,
            label: col.title,
            text: col.text,
            type: col.type,
            editable: is_editable,
          });
        });
        this.columns = columns;
      }
    },
    setGroupedBoardHeight(grouped_items) {
      // this.tasks = grouped_items;
      let max_rows = 14; // for internal scroll to appear

      // reset all boards' height, otherwise they appear with large empty rows
      for (let key in this.tasks) {
        let _board = this.tasks[key];
        _board.height = "auto";
      }

      for (let key in grouped_items) {
        let _board = grouped_items[key];
        _board.height = "auto";
        // mobile - list all items without internal vertical scroll
        // since it interferes with the page scroll
        // desktop - list items within a fixed container width
        // vertical and horizontal scroll
        if (window.innerWidth > 992) {
          if (_board && _board.length > max_rows) {
            if (this.search_term == "") _board.height = 960;
          }
        }
      }
    },
    sortByName(column, prop = "name", order) {
      let default_order = order ? order : "ascending";

      this.sort_props = { column, prop, default_order };
      this.data.sort((a, b) => {
        // text sort
        let a_text = a.name;
        let b_text = b.name;
        if (default_order && default_order.trim() == "ascending") {
          return a_text > b_text ? 1 : b_text > a_text ? -1 : 0;
        }
        return b_text > a_text ? 1 : a_text > b_text ? -1 : 0;
      });
    },
    sort({ column, prop, order }) {
      function sortByCreatedAt(a, b) {
        return a.created_at > b.created_at
          ? 1
          : b.created_at > a.created_at
            ? -1
            : 0;
      }

      const isNameCol = column && column.fixed;
      if (isNameCol) {
        // first column: name
        this.sortByName(column, prop, order);
        return;
      }

      this.sort_props = { column, prop, order };

      // reset to default
      if (!order) {
        return;
      }

      this.data.sort((a, b) => {
        let col_a = _.find(a.column_values, (c) => c.title == prop);
        let col_b = _.find(b.column_values, (c) => c.title == prop);

        if (!col_a || !col_b) return;

        // sort by date - text sort does not work
        // use YYYY-MM-DD format in .value.date for sorting
        if (col_a && col_a.type == "date" && col_b && col_b.type == "date") {
          let a_date = JSON.parse(col_a.value).date;
          let b_date = JSON.parse(col_b.value).date;

          if (order && order.trim() == "ascending")
            return a_date > b_date ? 1 : b_date > a_date ? -1 : 0;
          return b_date > a_date ? 1 : a_date > b_date ? -1 : 0;
        } else if (
          (col_a &&
            col_a.type == "numeric" &&
            col_b &&
            col_b.type == "numeric") || (col_a &&
              col_a.type == "numbers" &&
              col_b &&
              col_b.type == "numbers")
        ) {
          // monday returns numeric values as string instead of number
          // this causes sort issue
          // remove all commas, otherwise sort fails
          if (col_a.value && col_a.value.indexOf(",")) {
            col_a.value = col_a.value.replaceAll(",", "");
          }
          if (col_b.value && col_b.value.indexOf(",")) {
            col_b.value = col_b.value.replaceAll(",", "");
          }
          let a_num = JSON.parse(col_a.value);
          let b_num = JSON.parse(col_b.value);

          if (a_num) a_num = Number(a_num);
          if (b_num) b_num = Number(b_num);

          if (a_num == b_num) {
            // sort by updated_at if the text is the same
            // otherwise the records may jumble after update
            return sortByCreatedAt(a, b);
          }
          if (order && order.trim() == "ascending")
            return a_num > b_num ? 1 : b_num > a_num ? -1 : 0;
          return b_num > a_num ? 1 : a_num > b_num ? -1 : 0;
        } else if (["updated_at", "created_at"].includes(prop)) {
          let a_text =
            a[prop] && typeof a[prop] == "string"
              ? a[prop].toLowerCase()
              : a[prop];
          let b_text =
            b[prop] && typeof b[prop] == "string"
              ? b[prop].toLowerCase()
              : b[prop];

          if (order && order.trim() == "ascending") {
            return a_text > b_text ? 1 : b_text > a_text ? -1 : 0;
          }
          return b_text > a_text ? 1 : a_text > b_text ? -1 : 0;
        } else {
          // text sort
          let a_text =
            col_a.text && typeof col_a.text == "string"
              ? col_a.text.toLowerCase()
              : "";
          let b_text =
            col_b.text && typeof col_b.text == "string"
              ? col_b.text.toLowerCase()
              : "";
          if (a_text == b_text) {
            // sort by updated_at if the text is the same
            // otherwise the records may jumble after update
            return sortByCreatedAt(a, b);
          }
          if (order && order.trim() == "ascending") {
            return a_text > b_text ? 1 : b_text > a_text ? -1 : 0;
          }
          return b_text > a_text ? 1 : a_text > b_text ? -1 : 0;
        }
      });
    },
    getColumnOptions(column) {
      return this.column_options[column.id];
    },
    setColumnOptions() {
      this.column_options = {};
      if (this.board_item_list && this.board_item_list.length > 0) {
        let board = this.board_item_list[0];
        let board_columns = board.columns;

        for (let i = 0; i < board_columns.length; i++) {
          let col = board_columns[i];

          if (col && (col.type == "color" || col.type == "dropdown" || col.type == "status")) {
            let labels = JSON.parse(col.settings_str).labels;
            if (labels instanceof Array) {
              // Details
              labels.sort((a, b) =>
                a.name.toLowerCase() > b.name.toLowerCase()
                  ? 1
                  : b.name.toLowerCase() > a.name.toLowerCase()
                    ? -1
                    : 0
              );
            } else if (labels instanceof Object) {
              // Progress, Type
              labels = Object.values(labels);
              labels.sort((a, b) =>
                a.toLowerCase() > b.toLowerCase()
                  ? 1
                  : b.toLowerCase() > a.toLowerCase()
                    ? -1
                    : 0
              );
            }
            this.column_options[col.id] = labels;
          }
        }
      }
    },
    formatFields() {
      let board = this.board_item_list[0];
      if (board) {
        board.items.map((i) => {
          i.show = true;
          // format numeric fields with thousands commas
          i.column_values.map((col) => {
            if (col && (col.type == "numeric" || col.type == "numbers") && col.value) {
              col.value = numeral(col.value).format("0,0.[00]");
              col.text = col.value;
            }
          });
        });
      }
    },
    setRowColors({ row, rowIndex }) {
      if (rowIndex % 2 == 0) {
        return "row-bg";
      } else return "alternate-bg";
      return "";
    },
    onResize() {
      this.window_height = window.innerHeight;
    },
    expandAllGroups(board_items) {
      // auto expand all groups
      let nonEmptyGroups = Object.keys(board_items).length;
      this.opened_groups = [];
      for (let i = 0; i < nonEmptyGroups; i++) {
        this.opened_groups.push(i.toString());
      }
    },
    is_creator(creator_id) {
      return store.state.user.me.monday_me.id == creator_id;
    },
    setDataDebounced: debounce(function (search_term) {
      // debounce to reduce lag time between input and results
      if (!this.board_item_list || this.board_item_list.length == 0) return;

      let board = this.board_item_list[0];
      this.search_term_display = search_term;

      // search across all fields
      let search_terms;
      if (search_term.indexOf(" ") > 0) {
        search_terms = search_term.split(" ");
      } else search_terms = [search_term];

      if (board && board.items) {
        let filtered = board.items.filter((item) => {
          item.show = false;
          return search_terms.every(function (term) {
            return item.column_values.find(function (t) {
              return (
                (!t.title.startsWith("_") &&
                  t.text &&
                  t.text.toLowerCase().includes(term.toLowerCase())) ||
                item.name.toLowerCase().includes(term.toLowerCase())
              );
            });
          });
        });
        filtered.map((f) => (f.show = true));
        this.data = filtered;

        let board_items = _.groupBy(this.data, "group.title");
        this.setGroupedBoardHeight(board_items);
        this.table_key += 1;
      }
    }, 500),
    setupBoard() {
      this.is_first_load = true;
      this.refresh_data = true;
      this.default_sort = true;
      this.should_expand_all_groups = true;
      this.search_term = "";
      this.search_term_display = "";
    },
  },
  computed: {
    permissions() {
      return store.state.user.me.permissions;
    },
    is_admin() {
      return store.state.user.me.monday_me.is_admin == true;
    },
    board_item_messages() {
      return store.state.monday.board_item_messages;
    },
    board_item_list() {
      return store.state.monday.board_items;
    },
    item_list() {
      if (!store.state.monday.board_items[0]) return;

      return store.state.monday.board_items[0].items;
    },
    empty_board_groups() {
      // board groups that do not have items
      let board_groups =
        this.board && this.board.length > 0 ? this.board[0].groups : [];

      for (let key in this.tasks) {
        _.remove(board_groups, (grp) => {
          return grp.id == key;
        });
      }
      return board_groups;
    },
  },
  watch: {
    $route(to, from) {
      this.setupBoard();
    },
    search_term: {
      handler(search_term) {
        this.setDataDebounced(search_term);
        if (search_term == "") {
          this.search_term_display = "";
        }
      },
      immediate: true,
    },
    board_item_messages(new_val, old_val) {
      if (new_val) {
        this.messages = new_val;
      }
    },
    item_list(new_val, old_val) {
      let items = new_val;
      items = _.map(items, (i) => {
        i.group.position = Number(i.group.position);
        return i;
      });
      items.sort((a, b) => a.group.position - b.group.position);
      let board_items = _.groupBy(items, "group.id");
      if (this.refresh_data) {
        items.map((i) => {
          i.show = true;
          // format numeric fields with thousands commas
          i.column_values.map((col) => {
            if (col && (col.type == "numeric" || col.type == "numbers") && col.value) {
              col.value = numeral(col.value).format("0,0.[00]");
              col.text = col.value;
            }
          });
        });

        this.data = items;
        if (this.default_sort) {
          this.sort({ prop: "Progress", order: "ascending" });
          this.default_sort = false;
        }
        this.sort_props = null;

        if (this.is_first_load) {
          this.is_first_load = false;
          if (this.$refs.search) this.$refs.search.focus();
        }
        if (this.should_expand_all_groups) this.expandAllGroups(board_items);
      }
      this.tasks = board_items;

      this.setGroupedBoardHeight(board_items);
      this.setBoardColumns(board_items);
      this.setColumnOptions();

      if (this.refresh_table) {
        this.table_key += 1;
        this.refresh_table = false;
      }
      // this.table_key += 1; // re-render table, otherwise board height does not take effect
      // this.setDataDebounced(this.search_term);
    },
    board_id(new_val, old_val) {
      if (new_val.board_id !== old_val.board_id) {
        this.table_key += 1;
      }
    },
  },
  filters: {
    formatted: function (value) {
      if (!value) return "";
      return moment(value).format("YYYY-MM-DD");
    },
  },
  mounted() {
    // prevent browser from opening file when file is dropped
    window.addEventListener(
      "dragover",
      function (e) {
        e = e || event;
        e.preventDefault();
      },
      false
    );
    window.addEventListener(
      "dragenter",
      function (e) {
        e = e || event;
        e.preventDefault();
      },
      false
    );
    window.addEventListener(
      "drop",
      function (e) {
        e = e || event;
        e.preventDefault();
      },
      false
    );
    // end

    window.mobileAndTabletCheck = function () {
      let check = false;
      if (
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        )
      ) {
        check = true;
      }
      return check;
    };

    // Set first 2 cols to non-fixed on mobile,
    // otherwise unable to scroll table
    this.is_desktop = window.mobileAndTabletCheck() ? false : true;
    this.should_expand_all_groups = true;
  },
};
</script>
<style lang="scss">
#updateTaskModal .modal-dialog,
.modal-content {
  @media (min-width: 992px) {
    /* % of window height */
    height: 95%;
  }
}

.el-table .alternate-bg {
  background: #f8f9fe !important;
  height: 56px;
}

.el-table .row-bg {
  background: #ffffff !important;
  height: 56px;
}

.highlight {
  color: #39b3e0;
}

.bg-highlight {
  background-color: #39b3e0;
  color: #fff;
}

.important-field {
  font-weight: 600;
  color: #39b3e0;
  font-size: 13px;
}

.regular-field {
  font-weight: 600;
  font-size: 13px;
}

.btn-ellipsis:hover {
  background-color: #39b3e0;
  color: #ffffff !important;
  cursor: pointer;
}

.btn-save {
  color: #2dce89;

  &:hover {
    background-color: #2dce89;
    color: #ffffff !important;
    cursor: pointer;
  }
}

.btn-cancel {
  color: #f5365c;

  &:hover {
    background-color: #f5365c;
    color: #ffffff !important;
    cursor: pointer;
  }
}

.text-status {
  font-size: 13px;
  font-weight: 700;
}

.form-text {
  padding: 5px 0;
}

// div.el-table .el-table__row {
//   background: #fff !important;
// }
div.el-table tbody td,
div.el-table thead th {
  padding-top: 6px;
  padding-bottom: 6px;
}

.el-table__row td:nth-child(2) {
  padding: 0 0 0 15px;
}

// .el-table__row td:nth-child(3) {
//   padding: 0;
// }

.preview {
  max-height: 200px;
}

#task_form {
  width: 100%;
  margin-bottom: 1.5rem;

  & td label {
    margin-top: 0.75rem;
    margin-bottom: 0.2rem;
  }

  .el-date-editor.el-input,
  .el-date-editor.el-input__inner {
    width: auto;
    display: block;
  }

  .form-group {
    margin-bottom: 0;
  }

  .form-control,
  input {
    font-size: 12px;
    width: 100%;
  }
}

.no-tasks {
  padding: 15px;
  box-shadow: none;

  & i {
    font-size: 44px;
  }
}

// fix horizontal scrollbar for board is hidden below table on first load
.el-table--scrollable-x .el-table__body-wrapper {
  z-index: 1;
}

// comments
// #comments // modal
.modal-body {
  // padding: 0 1.25rem 1.25rem;
  padding: 0 20px 20px;
}

.trash-icon {
  cursor: pointer;
  margin-left: 10px;
  color: #ccc;
}

.trash-icon:hover .trash-icon-red:before {
  content: "\f1f8";
  color: red;
}

*:focus {
  outline: none;
}

// .el-submenu__title {
.bg-grey {
  background-color: #e3e3e3;
}

.title {
  font-size: 16px;
  font-weight: 600;
  color: #33aadb;
  padding-right: 1rem;
}

.el-icon-arrow-down:before {
  color: #33aadb;
  font-weight: bold;
}

.tac .el-menu {
  border-radius: 5px;
  border: none;
}

.el-submenu__title {
  color: #525f7f;
  height: auto;
  white-space: normal;
}

.btn-new-task {
  background-color: transparent;
  border: none;
  display: inline-block;

  & .btn {
    margin-bottom: 0.4rem;
  }
}

.btn-inner--icon i.fas {
  color: #39b3e0;
}

// error
pre {
  white-space: normal;
}

// search box
#searchBox {
  border-color: #33aadb;
  border-width: 3px;
  outline: 0;
}

#searchBox:focus {
  border-width: 3px;
}

// sort caret
// .el-table .el-table__header-wrapper .sort-caret {
//   border: 1px solid transparent;
// }
.el-table .el-table__header-wrapper .ascending .sort-caret.ascending {
  border-bottom-color: #fff;
}

.el-table .el-table__header-wrapper .descending .sort-caret.descending {
  border-top-color: #fff;
}

.el-table .sort-caret {
  left: 5px;
}

.el-table .caret-wrapper {
  background-color: #33aadb;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  left: 5px;
}

// fixed column - name
.el-table .el-table__fixed-header-wrapper .sort-caret.ascending {
  top: -1px;
}

.el-table .el-table__fixed-header-wrapper .sort-caret.descending {
  bottom: -1px;
}

.el-table .el-table__fixed-header-wrapper .ascending .sort-caret.ascending {
  border-bottom-color: #fff;
}

.el-table .el-table__fixed-header-wrapper .descending .sort-caret.descending {
  border-top-color: #fff;
}

p {
  font-weight: 500;
}
</style>
